/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateRecordingEnvelopePayloadContributionsInner
 */
export interface CreateRecordingEnvelopePayloadContributionsInner {
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadContributionsInner
     */
    role: string;
    /**
     * Required for add; from lookup_client_aliases response
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadContributionsInner
     */
    personaId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadContributionsInner
     */
    dataCategory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadContributionsInner
     */
    sourceUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadContributionsInner
     */
    notes?: string | null;
}

/**
 * Check if a given object implements the CreateRecordingEnvelopePayloadContributionsInner interface.
 */
export function instanceOfCreateRecordingEnvelopePayloadContributionsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "role" in value;

    return isInstance;
}

export function CreateRecordingEnvelopePayloadContributionsInnerFromJSON(json: any): CreateRecordingEnvelopePayloadContributionsInner {
    return CreateRecordingEnvelopePayloadContributionsInnerFromJSONTyped(json, false);
}

export function CreateRecordingEnvelopePayloadContributionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRecordingEnvelopePayloadContributionsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'role': json['role'],
        'personaId': !exists(json, 'persona_id') ? undefined : json['persona_id'],
        'dataCategory': !exists(json, 'data_category') ? undefined : json['data_category'],
        'sourceUrl': !exists(json, 'source_url') ? undefined : json['source_url'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
    };
}

export function CreateRecordingEnvelopePayloadContributionsInnerToJSON(value?: CreateRecordingEnvelopePayloadContributionsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'role': value.role,
        'persona_id': value.personaId,
        'data_category': value.dataCategory,
        'source_url': value.sourceUrl,
        'notes': value.notes,
    };
}

